import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import UNKNOWN_AVATAR_SVG from 'images/ic_telavox_unknown-contact.svg';
import UserAvatar from 'flow/components/ui-components/UserAvatar';
import { getFlowExtensionContactAvatar } from 'flow/utils';
import { getContactBackgroundColor } from 'flow/utils/extension-utils-TW';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectContact } from 'flow/selectors/ExtensionSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
var ExtensionContactAvatar = function ExtensionContactAvatar(_ref) {
  var extensionKey = _ref.extensionKey,
    contact = _ref.contact,
    ignoreAvatarResource = _ref.ignoreAvatarResource,
    size = _ref.size,
    status = _ref.status,
    lazyLoad = _ref.lazyLoad;
  var resolvedContact = useAppSelector(function (state) {
    return contact || selectContact(state, extensionKey);
  });
  var standardProps = {
    status: status,
    size: size,
    lazyLoad: lazyLoad
  };
  if (!resolvedContact) {
    // This case can happen when the contact no longer exists.
    return /*#__PURE__*/_jsx(UserAvatar, _objectSpread({
      src: UNKNOWN_AVATAR_SVG
    }, standardProps));
  }
  if (resolvedContact.get('avatarResource') && !ignoreAvatarResource) {
    return /*#__PURE__*/_jsx(UserAvatar, _objectSpread({
      src: getFlowExtensionContactAvatar(resolvedContact)
    }, standardProps));
  }
  var initials = extractContactInitials(resolvedContact);
  if (initials) {
    return /*#__PURE__*/_jsx(UserAvatar, _objectSpread(_objectSpread({
      className: getContactBackgroundColor(resolvedContact)
    }, standardProps), {}, {
      children: initials
    }));
  }

  // A contact carrying only a company name yields no initials, and an avatar with
  // neither image nor initials paints nothing at all. Same picture as no contact.
  return /*#__PURE__*/_jsx(UserAvatar, _objectSpread({
    src: UNKNOWN_AVATAR_SVG
  }, standardProps));
};

/** The initials an avatar draws, from the names themselves — for a caller that
 *  holds the names but no contact to read them off. */
export var initialsFromNames = function initialsFromNames() {
  var firstName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var lastName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return "".concat(firstName.charAt(0)).concat(lastName.charAt(0)).toUpperCase();
};
export var extractContactInitials = function extractContactInitials(contact) {
  return initialsFromNames(contact.get('firstName', ''), contact.get('lastName', ''));
};
export default ExtensionContactAvatar;